import { token } from './token';

// Namespaced auth module. Structured for easy expansion (e.g. a `users` sub-module
// for admin user management, mirroring tmc-local-frontend's store/auth/ layout)
// without needing to restructure this module.
export const auth = {
  namespaced: true,
  modules: {
    token,
  },
};

export default auth;
